<template>
  <div class="container have-footer mcontainer">
    <!--    <div class="flex-column justify-content-center align-items-center" style="height: 1.7rem">-->
    <!--      <i class="title">发现</i>-->
    <!--    </div>-->
    <top-bar :title="'活动详情'" :showBack="true" @back="$router.go(-1)">
    </top-bar>
    <div class="main-content-top0" style="height: calc(100vh - 2.4rem)">
      <div class="flex-column align-items-center p01 bw wv100">
        <img
          :src="VUE_APP_API_URL + `/home/getImage?id=` + data.image"
          style="width: 100%;"
        />
        <div class="flex-row wv100" style="margin-top: 0.1rem">
          <div
            class="flex-column justify-content-center "
            style="width: calc(100% - 1.8rem);font-weight: 600;color: #333333;
            font-size: 0.4rem;text-align: left;line-height: 0.4rem;padding-left: 0.2rem"
          >
            <i>{{ data.activityTitle }}</i>
          </div>
          <div
            style="width:1.5rem;height:0.4rem;"
            class="flex-column justify-content-start align-items-center search-button"
            :style="{
              background: initBackgroud(data)
            }"
          >
            <i>{{ initValue(data) }}</i>
          </div>
        </div>
      </div>
      <div class="flex-column justify-content-center align-items-center">
        <div
          class="flex-column  p01 bw mt01"
          style="width: calc(100% - 0.2rem);padding: 0.2rem;border-radius: 0.1rem"
        >
          <div class="flex-row mt01">
            <i class="label"><em></em>活动时间</i>
          </div>
          <div class="flex-row mt01" style="padding-left: 0.1rem">
            <i
              >{{ data.beginDate ? data.beginDate.substr(0, 10) : "" }}至{{
                data.endDate ? data.endDate.substr(0, 10) : ""
              }}</i
            >
          </div>
        </div>
        <div
          class="flex-column  p01 bw mt01"
          style="width: calc(100% - 0.2rem);padding: 0.2rem;border-radius: 0.1rem"
        >
          <div class="flex-row mt01">
            <i class="label"><em></em>活动地址</i>
          </div>
          <div class="flex-row mt01" style="padding-left: 0.1rem">
            <i>{{ data.addr }}</i>
          </div>
        </div>
        <div
          class="flex-column  p01 bw mt01"
          style="width: calc(100% - 0.2rem);padding: 0.2rem;border-radius: 0.1rem"
        >
          <div class="flex-row mt01">
            <i class="label"><em></em>主办方</i>
          </div>
          <div class="flex-row mt01" style="padding-left: 0.1rem">
            <i>{{ data.leaguefullname }}</i>
          </div>
        </div>
        <div
          class="flex-column  p01 bw mt01"
          style="width: calc(100% - 0.2rem);padding: 0.2rem;border-radius: 0.1rem"
        >
          <div class="flex-row mt01">
            <i class="label"><em></em>移动电话</i>
          </div>
          <div class="flex-row mt01" style="padding-left: 0.1rem">
            <i>{{ data.tel }}</i>
          </div>
        </div>
        <div
          class="flex-column  p01 bw mt01"
          style="width: calc(100% - 0.2rem);padding: 0.2rem;border-radius: 0.1rem"
        >
          <div class="flex-row mt01">
            <i class="label"><em></em>活动介绍</i>
          </div>
          <div class="flex-row mt01" style="padding-left: 0.1rem">
            <i>{{ data.descText }}</i>
          </div>
        </div>
        <div
          class="flex-column justify-content-center align-items-center sibment"
          @click="signUp"
        >
          <b style="">我要报名</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivity, getDicts, signUp } from "@/api/home";
import { VUE_APP_API_URL } from "@utils";
import topBar from "../top-bar";
import top from "@/assets/home_new/activity/add.png";

export default {
  name: "acyivity_second_level",
  components: {
    topBar
  },
  data() {
    return {
      data: {},
      VUE_APP_API_URL: VUE_APP_API_URL,
      top: top
    };
  },
  created() {
    this.route = this.$route.query;
    this.initDicts();
    this.initData();
  },
  mounted() {},
  destroyed() {},
  methods: {
    initBackgroud(item) {
      if (item.registeredCount > 0)
        return "linear-gradient(to right, #7EEC63, #008302)";
      if (item.ended) return "linear-gradient(to right, #808080, #808080";
      else return "linear-gradient(to right, #0cb1fe, #0e74ff)";
    },
    initValue(item) {
      if (item.registeredCount > 0) return "已报名";
      return item.ended ? "已结束" : "报名中";
    },
    back() {
      this.showMap = false;
    },
    initDicts() {
      var _this = this;
      getDicts({ dictName: "activity_type" })
        .then(res => {
          console.info(res);
          _this.typeList = res;
        })
        .catch(e => {
          console.info(e);
          _this.$message.error("网络请求异常!" + e);
        });
    },
    initData() {
      var _this = this;
      getActivity({ id: this.route.id })
        .then(res => {
          console.info(res);
          _this.data = res[this.route.id][0];
        })
        .catch(e => {
          console.info(e);
          _this.$message.error("网络请求异常!" + e);
        });
    },
    signUp() {
      var _this = this;

      _this.$dialog.loading.open();
      signUp({activityId: parseInt(this.route.id) })
        .then(res => {
          _this.$dialog.loading.close();
          console.info(res);
          this.$tip({
            title: "提示",
            show: true,
            message: "报名成功",
            onConfirm: function() {}
          });
        })
        .catch(e => {
          _this.$dialog.loading.close();
          console.info(e);
          this.$tip({
            title: "提示",
            show: true,
            message: "请求异常!" + e.data,
            onConfirm: function() {}
          });
        });
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/flex.css";
@import "../../assets/css/font-title.css";
@import "../../assets/css/msg.css";

.mcontainer {
  background-color: #f1f1f1;
  /*background: url(../../assets/home_new/t4.jpg);*/
  background-size: 100% auto;
  background-repeat: no-repeat;
}

.search-button {
  height: 0.4rem;
  width: calc(100% - 0.2rem);
  text-align: center;
  font-size: 0.28rem;
  color: #ffffff;
  background: linear-gradient(to right, #0cb1fe, #0e74ff);
  border-radius: 0.1rem;
}
</style>
